export const MIGRATION_ENABLED = true;
export const MIGRATION_MOCK_ENABLED = false;
export const MIGRATION_REVIEW_HOURS = 24;
export const MIGRATION_WELCOME_DISMISSED_KEY = 'migration-welcome-dismissed';
export const MIGRATION_NEW_APP_URL: string = 'https://next.vestmarkets.com';
export const MIGRATION_NEW_APP_SIGN_IN_URL = `${MIGRATION_NEW_APP_URL}?login=1`;
export const MIGRATION_NEW_APP_VEST_CAPITAL_URL = `${MIGRATION_NEW_APP_URL}/vest-capital`;
export const MIGRATION_NEW_APP_CAPITAL_PLANS_URL = `${MIGRATION_NEW_APP_VEST_CAPITAL_URL}#plans`;
export const MIGRATION_CHANGES_URL: string =
  'https://docs.vestmarkets.com/migration-notices';

export const MIGRATION_POLLING = {
  /** `pending`, `in_progress`, `unknown`. */
  active: 5_000,
  /** `blocked`, `failed` — an operator can move it. */
  parked: 60_000,
  /** `429` / `503` and any other transport error. */
  backoff: 30_000,
} as const;
